module.exports = __webpack_public_path__ + "img/logo.55a2845c.svg";